import { formatWei } from "@/utils/filters";
import { throttle } from "lodash-es";

export default function() { 
  return {
    namespaced: true,
    state: () => ({
      gasData: null,
      ethPrice: null,
    }),
    actions: {
      init({dispatch}) {
        dispatch('connectPriceFeed');
        dispatch('connectGasPrice');
      },
      connectPriceFeed({ commit }) {
        const socket = new WebSocket("wss://ftx.com/ws/");
  
        socket.onopen = () => {
          socket.send(
            JSON.stringify({
              op: "subscribe",
              channel: "ticker",
              market: "ETH-PERP",
            })
          );
        };
        
        const debounced = throttle(function ({ data }) {
          
          data = JSON.parse(data);
          if (data.data) {
            commit('setEthPrice', data.data.bid);
          }
        }, 5000);
        socket.onmessage = debounced;
      },
      connectGasPrice({ commit }) {
        const socket = new WebSocket("wss://gasgas.io/prices");
  
        socket.onmessage = ({ data }) => {
          commit('setGasData', JSON.parse(data).data)
        };
      },
    },
    mutations: {
      setEthPrice(state, ethPrice) {
        state.ethPrice = ethPrice;
      },
      setGasData(state, gasData) {
        state.gasData = gasData;
      }
    },
    getters: {
      gasData(state) {
        return state.gasData;
      },
      ethPrice(state) {
        return state.ethPrice;
      },
      tradeCost(state) {
        if (!state.gasData || !state.ethPrice) {
          return null;
        }

        return (
          formatWei(state.gasData?.fast) *
          state.ethPrice *
          310000
        );
      },
      gasPriceInGwei(state) {
        if (!state.gasData) {
          return null;
        }
        return formatWei(state.gasData?.fast, "Gwei");
      },
      presetGasPriceInGwei(state) {
        return preset => {
          if (!state.gasData) {
            return null;
          }
          return formatWei(state.gasData?.[preset], "Gwei");
        }
      },
      eip1559GasPriceInGwei(state) {
        return preset => {
          if (!state.gasData) {
            return null;
          }
          return {
            fee: formatWei(state.gasData?.eip1559?.[preset].maxFeePerGas,  "Gwei"),
            priorityFee: formatWei(state.gasData?.eip1559?.[preset].maxPriorityFeePerGas,  "Gwei"),
          }
        }
      }
    },
  }
}